import React from 'react';
import 'whatwg-fetch';

if (process.env.NODE_ENV !== 'production') {
    // Require '?performance' query parameter to activate why-did-you-update
    if(typeof window !== 'undefined' && window.location.search.indexOf('performance') !== -1) {
        let createClass = React.createClass; // eslint-disable-line
        Object.defineProperty(React, 'createClass', {
            set: (nextCreateClass) => {
                createClass = nextCreateClass;
            }
        });
        const { whyDidYouUpdate } = require('why-did-you-update');
        whyDidYouUpdate(React, { exclude: /^(Portal|Wrapped|Map)/ });
    }
}

import 'scss/app.scss';

import 'expose-loader?React!react';
import 'expose-loader?ReactDOM!react-dom';
import 'expose-loader?ReactDOMServer!react-dom/server';
import 'expose-loader?Components!components';

import { addLogoToPrintProjects } from 'utils';
import { GTMTrackingForEpiFormsHandler } from 'utils';

if(typeof window !== 'undefined') {
    window.Components.MapLocationBlock = require('components/MapLocationBlock');
    window.Components.ProjectListPage = require('components/ProjectListPage');

    require('smoothscroll-polyfill').polyfill();
}

// Prevent clicks on disabled anchor tags
if(typeof document !== 'undefined') {
    document.addEventListener('click', e => {
        if(e.target && e.target.tagName === 'A') {
            if(e.target.getAttribute("disabled") !== null) e.preventDefault();
        }
    });

    if(document.body.classList.contains("project-print-page")) {
        addLogoToPrintProjects();
    }

    GTMTrackingForEpiFormsHandler();
}


// WEBPACK FOOTER //
// ./src/app.js